import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let AppNotificationsOptions: LazyOption = createLazyOption(
    {
        key: 'appNotifications',
        titleStringKey: 'optionTitle_notificationsInAppNotifications',
        searchTermsStringKey: 'optionTitle_notificationsInAppNotifications',
        isHidden: () => !isFeatureEnabled('fwk-inAppNotifications'),
    },
    lazyFullModule,
    m => m.default
);
export default AppNotificationsOptions;
